// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--raw-header-bg:#3d46cd;--raw-body-bg:#edf7ff;--raw-font-family:verdana;--raw-border-color:#ddd;--raw-padding:1rem;--raw-radius:1rem;--raw-header-size:1.55em;--text-white:#fff}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
